import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import Swal from "sweetalert2";

// Componentes
import AgendarVisita from "./AgendarVisita";
import Avance from "./Avance";
import CambiaEstado from "./CambiaEstado";
import FichaTecnica from "../FichaTecnica/FichaTecnica";
import CreaEncuesta from "../Encuestas/CreaEncuesta";
import InfoProgramacionHoraria from "./InfoProgramacionHoraria";
import InfoCapacidadInstalada from "../Funciones/InfoCapacidadInstalada";
import { decryptAES } from "../Crypto";
import Cookies from "universal-cookie";

const IndexEvaluador = () => {
  const { username } = useParams();
  const cookie = new Cookies();
  const [correoDesencriptado, setCorreoDesencriptado] = useState("");
  const [solicitudes, setSolicitudes] = useState([]);

  // ✅ Configuración de autorización API
  const authConfig = {
    auth: {
      username: "BasicAuth@icontec.org",
      password: "yQLzqmR7eZSuAmQZUqhY",
    },
  };

  // ✅ Alerta de bienvenida (solo se muestra una vez)
  const mostrarAlertaBienvenida = useCallback(() => {
    Swal.fire({
      title: "Bienvenido",
      text: "Haz clic en el botón para continuar",
      icon: "success",
      confirmButtonText: "Continuar",
    }).then(() => {
      localStorage.setItem("bienvenida_mostrada", "true");
      setTimeout(() => window.location.reload(), 500); // 🔧 Tiempo para permitir guardar cookies
    });
  }, []);

  // ✅ Carga inicial del componente
  useEffect(() => {
    if (!localStorage.getItem("bienvenida_mostrada")) {
      mostrarAlertaBienvenida();
      return;
    }

    try {
      const correo = decryptAES(username);
      setCorreoDesencriptado(correo);

      // ✅ Guardar cookie HASH al desencriptar el correo
      const cookie = new Cookies();
      cookie.set("hash", encodeURIComponent(username), {
        path: "/",
        secure: false,
        sameSite: "lax",
      });

      cargarUsuario(correo);
    } catch (err) {
      console.error("❌ Error al desencriptar el correo:", err);
    }
  }, [username, mostrarAlertaBienvenida]);
  const [hashCookie, setHashCookie] = useState("");

  useEffect(() => {
    const cookie = new Cookies();
    const hash = cookie.get("hash");
    if (hash) setHashCookie(decodeURIComponent(hash));
  }, []);

  // ✅ Función para cargar usuario y guardar cookies
  const cargarUsuario = async (correo) => {
    try {
      // 🔽 Normalizamos el correo
      const correoNormalizado = correo.trim().toLowerCase();

      const { data } = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/obtenerIdUsuario?correo=${correoNormalizado}`,
        authConfig,
      );

      // ✅ El API devuelve un objeto directo, no un array
      if (data && data.id) {
        const usuario = data;
        cookie.set("id", usuario.id, {
          path: "/",
          secure: false,
          sameSite: "lax",
        });
        // 🔐 Guardar cookies

        cookie.set("Nombre", usuario.nombre, {
          path: "/",
          secure: false,
          sameSite: "lax",
        });
        cookie.set("tipo_Usuario", usuario.tipo_Usuario, {
          path: "/",
          secure: false,
          sameSite: "lax",
        });
        cookie.set("institucionid", usuario.institucionId, {
          path: "/",
          secure: false,
          sameSite: "lax",
        });

        Swal.fire({
          title: "✅ Bienvenido",
          html: `
        
          <p><strong>Nombre:</strong> ${usuario.nombre}</p>
        `,
          icon: "success",
        });

        cargarSolicitudes(usuario.id); // ✅ Ahora si cargamos las solicitudes
      } else {
        Swal.fire({
          title: "⚠️ Usuario no encontrado",
          text: "Verifique el correo o contacte con soporte.",
          icon: "warning",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "❌ Error al cargar usuario",
        text: error.message,
        icon: "error",
      });
    }
  };

  // ✅ Función para cargar solicitudes
  const cargarSolicitudes = async (evaluadorId) => {
    try {
      const { data } = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerQSolicitudesPorEvaluador?EvaluadorId=${evaluadorId}`,
        authConfig,
      );
      if (data?.length > 0) {
        cookie.set("institucionid", data[0].institucionId, {
          path: "/",
          secure: false,
          sameSite: "lax",
        });
        setSolicitudes(data);
      } else {
        console.warn("⚠️ No hay solicitudes para este evaluador");
      }
    } catch (error) {
      console.error("❌ Error cargando solicitudes:", error);
    }
  };

  /**
   * 🔹 MENÚS REUTILIZABLES
   */
  const RepoMenu = ({ institucionId }) => (
    <PopupState variant="popover" popupId="repo-menu">
      {(popupState) => (
        <>
          <button className="btn btn-primary" {...bindTrigger(popupState)}>
            Información
          </button>
          <Menu {...bindMenu(popupState)}>
            {[
              ["Indicadores A&B", `/IndicadorEvaluadorAyB/${institucionId}`],
              [
                "Repositorio de Información",
                `/RepositorioEvaluador/${institucionId}`,
              ],
              [
                "Información de Trabajadores",
                `/InfoTrabajadoresEvaluador/${institucionId}`,
              ],
              ["Información de Anexos", `/InfoAnexos/${institucionId}`],
            ].map(([label, link], idx) => (
              <MenuItem key={idx} onClick={popupState.close}>
                <Link to={link}>{label}</Link>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </PopupState>
  );

  const ProcesosMenu = ({ solicitud, institucionId }) => (
    <PopupState variant="popover" popupId="procesos-menu">
      {(popupState) => (
        <>
          <button className="btn btn-primary" {...bindTrigger(popupState)}>
            Procesos
          </button>
          <Menu {...bindMenu(popupState)}>
            <MenuItem onClick={popupState.close}>
              <Link to={`/ProcesoSolicitud/${solicitud}/${institucionId}`}>
                Solicitudes
              </Link>
            </MenuItem>
            <MenuItem onClick={popupState.close}>
              <Link to={`/InformeAuto/${institucionId}/${solicitud}`}>
                Informe Autoevaluación
              </Link>
            </MenuItem>
            <MenuItem onClick={popupState.close}>
              <Link to={`/InfoServicios/${institucionId}`}>
                Información Servicios
              </Link>
            </MenuItem>
            <MenuItem onClick={popupState.close}>
              <Link to={`/ServiciosModalidadEvaluador/${institucionId}`}>
                Información Servicios Lab. Clínico
              </Link>
            </MenuItem>
            <InfoCapacidadInstalada institucionId={institucionId} />
          </Menu>
        </>
      )}
    </PopupState>
  );

  const ProcesoEvaluativoMenu = ({ item }) => (
    <PopupState variant="popover" popupId="evaluativo-menu">
      {(popupState) => (
        <>
          <button className="btn btn-dark" {...bindTrigger(popupState)}>
            Proceso Evaluativo
          </button>
          <Menu {...bindMenu(popupState)}>
            {item.nombre === "LIDER" && (
              <>
                <MenuItem>
                  <Link
                    to={`/AsignarTareas/${item.solicitud}/${item.tipoSolicitudId}`}
                  >
                    Distribución del Informe
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to={`/GestionOmLider/${item.institucionId}`}>
                    Priorización de OM
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link
                    to={`/AsignarOm/${item.solicitud}/${item.institucionId}`}
                  >
                    Asignar Om
                  </Link>
                </MenuItem>
              </>
            )}
            <MenuItem>
              <Link
                to={`/OmNoAgrupadasEvaluador/${item.institucionId}/${item.solicitud}`}
              >
                Hallazgos OM
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to={`/OmAgrupadas/${item.institucionId}`}>
                Om Agrupadas
              </Link>
            </MenuItem>
          </Menu>
        </>
      )}
    </PopupState>
  );

  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header text-center">
          <h6 className="font-weight-bold text-primary">
            Index Evaluador
            <div className="alert alert-info mt-2">
              <strong>Usuario:</strong> {correoDesencriptado || "Cargando..."}
            </div>
          </h6>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Rol</th>
                  <th>Institución</th>
                  <th>Solicitud</th>
                  <th>Tipo</th>
                  <th>Repositorio</th>
                  <th>Estado</th>
                  <th>Cambiar Estado</th>
                  <th>Procesos</th>
                  <th>Visita</th>
                  <th>Avance</th>
                  <th>Evaluativo</th>
                  <th>Instrumentos</th>
                  <th>Ficha</th>
                  <th>Informe</th>
                </tr>
              </thead>
              <tbody>
                {solicitudes.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.nombre}</td>
                    <td>{item.nombreInstitucion}</td>
                    <td>{item.solicitud}</td>
                    <td>{item.tipoSolicitud}</td>
                    <td>
                      <RepoMenu institucionId={item.institucionId} />
                    </td>
                    <td>{item.estado}</td>
                    <td>
                      {item.nombre === "LIDER" && (
                        <CambiaEstado
                          idSolicitud={item.solicitud}
                          estadoActualId={item.tipoEstadoId}
                        />
                      )}
                    </td>
                    <td>
                      <ProcesosMenu
                        solicitud={item.solicitud}
                        institucionId={item.institucionId}
                      />
                    </td>
                    <td>
                      {item.nombre === "LIDER" ? (
                        <div className="d-flex gap-2 justify-content-start">
                          <AgendarVisita
                            idEvaluador={item.evaluadorId}
                            idSolicitud={item.solicitud}
                          />
                          -
                          <InfoProgramacionHoraria
                            idEvaluador={item.evaluadorId}
                            idSolicitud={item.solicitud}
                            EsLider={item.nombre}
                          />
                        </div>
                      ) : (
                        <InfoProgramacionHoraria
                          idEvaluador={item.evaluadorId}
                          idSolicitud={item.solicitud}
                        />
                      )}
                    </td>

                    <td>
                      <Avance
                        idEvaluador={item.evaluadorId}
                        idSolicitud={item.solicitud}
                        rol={item.nombre}
                        tipoSolicitud={item.tipoSolicitudId}
                        idInstitucion={item.institucionId}
                      />
                    </td>
                    <td>
                      <ProcesoEvaluativoMenu item={item} />
                    </td>
                    <td>
                      <CreaEncuesta
                        idSolicitud={item.solicitud}
                        institucion={item.institucionId}
                      />
                    </td>
                    <td>
                      <FichaTecnica
                        idSolicitud={item.solicitud}
                        institucion={item.institucionId}
                        tipoSolicitud={item.tipoSolicitud}
                        ano={item.ano}
                      />
                    </td>
                    <td>
                      <Link
                        to={`/InformeEvaluador/${item.institucionId}/${item.solicitud}`}
                      >
                        Informe
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {solicitudes.length === 0 && (
              <div className="text-center text-muted mt-3">
                No hay solicitudes disponibles.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndexEvaluador;
